import { ApiTypes } from '@/types/server/api.types';
import { UserRole } from '@/types/server/enums.types';

export const loginPositionAdmin = async (
	password: string,
	positionPublicId: string
) => {
	const response = await fetch(
		`${import.meta.env.VITE_SERVER_API_PREFIX}/users/login`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				password,
				userRole: UserRole.positionAdmin,
				positionPublicId,
			}),
		}
	);

	const responseData = (await response.json()) as ApiTypes.TLoginResponse;

	return responseData;
};

export const loginCandidate = async (
	positionPublicId: string,
	candidateEmail: string,
	positionAdminAuthToken?: string
) => {
	const response = await fetch(
		`${import.meta.env.VITE_SERVER_API_PREFIX}/users/login`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-position-admin-token': positionAdminAuthToken ?? '',
			},
			body: JSON.stringify({
				candidateEmail,
				userRole: UserRole.candidate,
				positionPublicId,
			}),
		}
	);

	const responseData = (await response.json()) as ApiTypes.TLoginResponse;

	return responseData;
};

export const verifyCandidateOTP = async (
	candidateEmail: string,
	otp: string
) => {
	const response = await fetch(
		`${import.meta.env.VITE_SERVER_API_PREFIX}/users/verify-otp`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				candidateEmail,
				otp,
			}),
		}
	);

	const responseData =
		(await response.json()) as ApiTypes.TVerifyCandidateOTPResponse;

	return responseData;
};
